import React from 'react'
import { Cancel } from '../../assets'
import { t } from '../../miscellaneous/language'

const UserConfirmStatusCancel = ({updateStaticStatus}) => {
    return (
        <div className="after-order-card">
            <div className="after-order-status-container">
                <span className="after-order-title">{t.text.userCancel.title}</span>
                <span className="after-order-desc">{t.text.userCancel.desc}</span>
            </div>
            <div className="after-order-icon-container">
                <Cancel id="confirm-medium-icon" />
            </div>
        </div>
    )
}

export default UserConfirmStatusCancel